var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","pa-0":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"hidden-md-and-down",attrs:{"lg3":""}},[_c('PostsIndex')],1),_c('v-flex',[_c('Gmap'),_c('SearchBtns')],1)],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }